export enum Flags {
  MultiSite = "61a8",
}

const params = new URLSearchParams(window.location.search);

export const FLAGS = new Set<Flags>(params.getAll("flags") as Flags[]);
